class CompareProductsResults extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleExternalRemove = this.handleExternalRemove.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    // Listen for external remove event
    this.listeners.add(
      document,
      'compare:externalRemove',
      this.handleExternalRemove,
    )
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-compare-products-results-external-el="trigger"]',
    )

    if (!trigger) return

    await this.refreshResults(trigger.dataset.collection)

    window.drawers.activeDrawerKey = 'compare-products-results'
  }

  async handleExternalRemove (event) {
    const { collection, compareSize } = event.detail

    await this.refreshResults(collection)

    if (compareSize < 1) {
      window.drawers.activeDrawerKey = ''
    }
  }

  async refreshResults (collection) {
    try {
      const res = await window.BAO.sectionRenderer.fetchSingle(
        'compare-products-results',
        `/collections/${collection}`,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
      const section = newDOM.querySelector('.shopify-section') || newDOM

      this.els.body.element.innerHTML = section.innerHTML
    } catch (e) {
      console.error('Failed to refresh results:', e)
      window.drawers.activeDrawerKey = ''
    }
  }

  get collection () {
    return this.dataset.collection
  }
}

if (!customElements.get('compare-products-results')) {
  customElements.define('compare-products-results', CompareProductsResults)
}
